/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import { createBEM } from 'src/util/bem';
import './areaCascader.less';
import CommonSelect from '../SelectCustom/commonSelect';
import PublicApi from 'src/util/publicApi';
import { defaultNullValue } from 'src/config';
import { CommonUtil } from 'src/util/commonUtil';
let bem = createBEM('area-cascader');

export namespace AreaCascaderI {
    export interface PropsI {
        value: number[];
        type: number;
    }
}

@Component
export default class AreaCascader extends Vue.Component<any> {
    @Prop({
        type: Array,
    })
    value!: number[];

    @Prop({
        type: Number,
    })
    type!: number;

    provinceData: Array<{ id: number; name: string }> = [];
    cityData: Array<{ id: number; name: string }> = [];
    districtData: Array<{ id: number; name: string }> = [];

    input(index: number, vallue) {
        let newVal = [...this.value.slice(0, index), vallue, ...Array.from({ length: 2 - index }).map(i => defaultNullValue)];
        newVal[index] = vallue;

        this.$emit('input', newVal);
        if (index === 0) {
            this.cityData = [];
            this.districtData = [];
            this.queryCtity(vallue);
        } else if (index === 1) {
            this.districtData = [];
            this.queryDistrict(vallue);
        }
    }
    async queryCtity(id: number) {
        if (CommonUtil.isFieldEmpty(id)) {
            return;
        }
        let { code, data } = await PublicApi.getCity(id);
        if (code === 0) {
            this.cityData = data.map(i => ({ id: i.area_id, name: i.area_name })) as any;
        }
    }
    async queryDistrict(id: number) {
        if (CommonUtil.isFieldEmpty(id)) {
            return;
        }
        let { code, data } = await PublicApi.getDistrict(id);
        if (code === 0) {
            this.districtData = data.map(i => ({ id: i.area_id, name: i.area_name })) as any;
        }
    }

    async matchData() {
        await this.queryCtity(this.value[0]);
        await this.queryDistrict(this.value[1]);
    }

    async mounted() {
        let { code, data } = await PublicApi.getProvince();
        if (code === 0) {
            this.provinceData = data.map(i => ({ id: i.area_id, name: i.area_name })) as any;
        }
    }
    async setAreaByName(names: string[]) {
        let provinceName = names[0];
        let cityName = names[1];
        let districtName = names[2];
        let provicnce, city, district;
        try {
            provicnce = this.provinceData.find(i => i.name === provinceName)!;
            await this.queryCtity(provicnce.id);
            city = this.cityData.find(i => i.name === cityName)!;
            await this.queryDistrict(city.id);
            district = this.districtData.find(i => i.name === districtName)!;
            this.$emit('input', [provicnce.id, city.id, district.id])
        } catch (error) {
            let area: number[] = []
            provicnce && area.push(provicnce.id)
            city && area.push(city.id)
            district && area.push(district.id)
            this.$emit('input', area)
        }
    }

    getCurrentArea():{id: number, name: string}[] {
        let area:{id: number, name: string}[] = []
        if(!CommonUtil.isFieldEmpty(this.value[0])) {
            let provicnce = this.provinceData.find(i => i.id === this.value[0])!;
            provicnce && area.push(provicnce)
        }
        if(!CommonUtil.isFieldEmpty(this.value[1])) {
            let city = this.cityData.find(i => i.id === this.value[1])!;
            city && area.push(city)
        }
        if(!CommonUtil.isFieldEmpty(this.value[1])) {
            let district = this.districtData.find(i => i.id === this.value[2])!;
            district && area.push(district)
        }
        return area
    }

    render(h) {
        return (
            <div class={bem()}>
                <div style="flex:1">
                    <CommonSelect transfer dataSource={this.provinceData} value={this.value[0]} on-input={this.input.bind(this, 0)} />
                </div>
                <div style="flex:1">
                    <CommonSelect transfer dataSource={this.cityData} value={this.value[1]} on-input={this.input.bind(this, 1)} />
                </div>
                <div style="flex:1">
                    <CommonSelect transfer dataSource={this.districtData} value={this.value[2]} on-input={this.input.bind(this, 2)} />
                </div>
            </div>
        );
    }
}
